export default "__VITE_ASSET__B0L9WyFp__"